<template>
<el-menu background-color="#e49536" text-color="#fff" active-text-color="#ff0" style="width: 230px;" @select="select" ref="menu" :unique-opened="true" :default-active="getmenuindex">
	<div v-for="item in items" :key="item.index">
		<el-submenu :index="item.index" v-if="getPagePower(item.name)">
			<template slot="title">
				<i :class="item.icon" class="fs22" style="color: #fff;"></i>
				<span class="fs22 ml10">{{item.name}}</span>
			</template>
			<el-menu-item-group>
				<div v-for="childitem in item.child" :key="childitem.index">
					<el-menu-item :index="childitem.index" class="fs20" v-if="getPagePower(item.name+'/'+childitem.name)">{{childitem.name}}</el-menu-item>
				</div>
				
			</el-menu-item-group>
		</el-submenu>
	</div>
</el-menu>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'
export default{
	name:"mymenu",
	data() {
		return {
			items:[
				{
					index:"1",
					name:"系统设置",
					icon:"el-icon-setting",
					child:[
						{index:"1-1",name:"校区设置",router:"setsch"},
						{index:"1-2",name:"职务权限",router:"setjob"},
						{index:"1-3",name:"等级设置",router:"setdj"},
						{index:"1-4",name:"科目设置",router:"setsub"}
					]
				},{
					index:"2",
					name:"信息管理",
					icon:"el-icon-set-up",
					child:[
						{index:"2-1",name:"添加教师",router:"addtch"},
						{index:"2-2",name:"教师列表",router:"tchlist"},
						{index:"2-3",name:"我的信息",router:"myinf"},
					]
				},{
					index:"3",
					name:"教师数据",
					icon:"el-icon-date",
					child:[
						{index:"3-1",name:"课时导入",router:"inputhour"},
						{index:"3-2",name:"教师课时",router:"tchhour"},
						{index:"3-3",name:"教师测试",router:"tchtest"},
						{index:"3-4",name:"单生累计",router:"singeltotal"},
						{index:"3-5",name:"教师积分",router:"integral"}
					]
				},{
					index:"4",
					name:"数据分析",
					icon:"el-icon-finished",
					child:[
						{index:"4-1",name:"课消概况",router:"hourinf"},
						{index:"4-2",name:"课时分布",router:"assort"},
						{index:"4-3",name:"兼职排名",router:"othersort"}
					]
				},{
					index:"5",
					name:"资源库",
					icon:"el-icon-notebook-2",
					child:[
						{index:"5-1",name:"资源库",router:"xkw"},
						{index:"5-2",name:"我的下载",router:"downlist"},
					]
					// index:"5",
					// name:"试题库",
					// icon:"el-icon-notebook-2",
					// child:[
					// 	{index:"5-1",name:"权限设置",router:"testpower"},
					// 	{index:"5-2",name:"试题下载",router:"testdownload"},
					// 	{index:"5-3",name:"试题上传",router:"testupload"}
					// ]
					
				}
			],
			chooseindex:""
		}
	},
	computed:{
		...mapGetters('Tabs',['getmenuindex','getalltabs']),
		...mapGetters('User',['getPagePower']),
	},
	watch:{
		getmenuindex(e){
			this.chooseindex = e
		}
	},
	methods:{
		...mapMutations('Tabs',['addtab','setindex']),
		select(index,indexPath){
			if(index === this.chooseindex){
				return
			}
			this.chooseindex = index
			const obj =this.items.find((item)=>item.index===indexPath[0]).child.find((item)=>item.index===index)
			const tabindex = this.getalltabs.findIndex(e=>e.index===obj.index)
			if(tabindex>=0){
				this.setindex(tabindex)
				this.$router.push({name:obj.router})
				return
			}
			this.addtab(obj)
			this.$router.push({name:obj.router})
		}
	}
}
</script>

<style>
</style>
